import { ReactNode } from 'react'

import {
  StyledListItem,
  StyledList,
  StyledH3,
} from '../TextStyle'

export const usingTerms: { children: ReactNode; id: string }[] = [
  {
    children: (
      <>
        <StyledH3>1. Copyrights</StyledH3>
        <p>
           Unless otherwise stated, the copyright of all the information on the Website, including but not limited to documents and images, belongs to TRIAL Group.
        </p>
      </>
    ),
    id: 'copyright',
  },
  {
    children: (
      <>
        <StyledH3>2. Text and Contents</StyledH3>
        <p>
          Although TRIAL Group has taken the utmost care in posting information on the Website, we make no warranty of any kind regarding any errors or defects in the content of the Website. TRIAL Group shall not be liable for any damages resulting from the use of the Website.
          <br />
          Please note that the information on the Website may be subject to change or discontinuation without notice.
        </p>
      </>
    ),
    id: 'article',
  },
  {
    children: (
      <>
        <StyledH3>3. Prohibited Matters</StyledH3>
        <p>
          In addition to the acts prohibited by the provisions of the Terms, Users shall not engage in any of the following acts when using the Website.
        </p>
        <StyledList marginLeft="0.5" paddingLeft="0.5">
          <StyledListItem listType="article">
            Actions that infringe or may infringe the rights, interests, or privacy of TRIAL Group or any third party.
          </StyledListItem>
          <StyledListItem listType="article">
            Actions that cause or may cause trouble or damage to TRIAL Group or any third party.
          </StyledListItem>
          <StyledListItem listType="article">
            Actions that damage the reputation or credibility of TRIAL Group or any third party.
          </StyledListItem>
          <StyledListItem listType="article">
            Actions that are or may be offensive to public order and morals, or that violate or may violate laws, regulations, or ordinances.
          </StyledListItem>
          <StyledListItem listType="article">
            Criminal acts or acts that lead or may lead to criminal acts.
          </StyledListItem>
          <StyledListItem listType="article">
            Actions that are intended to conduct business or commercial activities using the Website, or actions in preparation for such activities.
          </StyledListItem>
          <StyledListItem listType="article">
            Actions that interfere with the operation of the Website or may interfere with the provision of services of TRIAL Group.
          </StyledListItem>
          <StyledListItem listType="article">
            Actions that use, provide, or may use or provide harmful programs such as computer viruses
          </StyledListItem>
          <StyledListItem listType="article">
            Any other acts that TRIAL Group deems inappropriate.
          </StyledListItem>
        </StyledList>
      </>
    ),
    id: 'restriction',
  },
  {
    children: (
      <>
        <StyledH3>4. Suspension or Shutdown of the Website</StyledH3>
        <p>
          TRIAL Group may suspend or shut down the Website (including temporary suspension) due to system maintenance (whether regular or irregular), force majeure such as natural disasters, unavoidable circumstances, or TRIAL Group&apos;s sole discretion. TRIAL Group shall not be liable for any disadvantage or damage, etc. incurred by Users due to their inability to use the Website.
        </p>
      </>
    ),
    id: 'stoppage',
  },
  {
    children: (
      <>
        <StyledH3>5. Subject Countries and Regions of Products and Services</StyledH3>
        <p>
          The information contained on the Website is related to products/services offered in Japan and can only be purchased/obtained by residents of Japan. If the country/region of supply is indicated individually in the content, or if the content is linked to the information of such country/region, such information shall take precedence.
        </p>
      </>
    ),
    id: 'region',
  },
  {
    children: (
      <>
        <StyledH3>6. Link to the Website</StyledH3>
        <p>
          Users are free to link to the Website if the link is to the top page.
          <br />
          However, Users shall follow the precautions below.
        </p>
        <ul>
          <li>
            <span style={{ color: '#002D65' }}>Precautions for Links</span>
          </li>
          <li>
            <StyledList marginLeft="0.5" paddingLeft="0.5">
              <StyledListItem listType="article">
                Please clearly indicate “TRIAL Group”.
              </StyledListItem>
              <StyledListItem listType="article">
                Please refrain from using the logo of TRIAL Group.
              </StyledListItem>
              <StyledListItem listType="article">
                Please display the Website in an independent window and clearly identify it as website of TRIAL Group.
              </StyledListItem>
              <StyledListItem listType="article">
                Links to the Website by the following types of websites are strictly prohibited.
                <StyledList marginLeft="1" paddingLeft="0.5">
                  <StyledListItem listType="disc">
                    Websites with content that infringes the rights of TRIAL Group or any third party.
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    Websites with content that causes misunderstanding, misconception, or annoyance to TRIAL Group or any third party.
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    Websites with content that offends public order and morals.
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    Websites with content related to illegal or potentially illegal expressions or activities.
                  </StyledListItem>
                  <StyledListItem listType="disc">
                    Other websites that TRIAL Group deems inappropriate as the link source.
                  </StyledListItem>
                </StyledList>
              </StyledListItem>
            </StyledList>
          </li>
          <li>
            <p>
              Please be aware that if you do not follow the linking methods and precautions described above, TRIAL Group may request the deletion of the link. 
              <br />
              Please remove the link immediately after the request is made.
            </p>
          </li>
        </ul>
      </>
    ),
    id: 'links',
  },
  {
    children: (
      <>
        <p>
          Date of Enactment :
          December 26, 2022
        </p>
      </>
    ),
    id: 'enactment',
  },
]

export const usingTermsLinks: {
  name: string
  anchor: string
}[][] = [
  [
    {
      name: '（ Copyrights）',
      anchor: 'copyright',
    },
    {
      name: '（Text and Contents）',
      anchor: 'article',
    },
    {
      name: '（Prohibited Matters）',
      anchor: 'restriction',
    },
  ],
  [
    {
      name: '（Suspension or Shutdown of the Website ）',
      anchor: 'stoppage',
    },
    {
      name: '（Subject Countries and Regions of Products and Services）',
      anchor: 'region',
    },
    {
      name: '（Link to the Website）',
      anchor: 'links',
    },
  ],
]
